import React from "react";
import styled from "styled-components";

const VerticalGap = styled.div`
  width: 100%;
  height: ${({ height }) => height};
  min-height: ${({ height }) => height};
  background-color: transparent;
`;

const HorizontalGap = styled.div`
  width: ${({ width }) => width};
  min-width: ${({ width }) => width};
  height: 100%;
  background-color: transparent;
`;

export { HorizontalGap, VerticalGap };
